import React, { useState } from "react";
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import RiderScroll from "@/components/RiderScroll";
import BookNowDialog from "@/components/BookNowDialog";
import LanguageDetectBanner from "@/components/LanguageDetectBanner";
import StructuredData from "@/components/StructuredData";
import Home from "@/pages/Home";
import Rentals from "@/pages/Rentals";
import About from "@/pages/About";
import Mission from "@/pages/Mission";
import FindUs from "@/pages/FindUs";
import Contact from "@/pages/Contact";
import GalleryPage from "@/pages/GalleryPage";

function PageWrap({ children }) {
  return (
    <motion.main
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.main>
  );
}

function AppRoutes({ openBook }) {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrap><Home onBookNow={() => openBook()} /></PageWrap>} />
        <Route path="/rentals" element={<PageWrap><Rentals onBookNow={(m) => openBook(m)} /></PageWrap>} />
        <Route path="/about" element={<PageWrap><About /></PageWrap>} />
        <Route path="/mission" element={<PageWrap><Mission /></PageWrap>} />
        <Route path="/find-us" element={<PageWrap><FindUs /></PageWrap>} />
        <Route path="/gallery" element={<PageWrap><GalleryPage /></PageWrap>} />
        <Route path="/contact" element={<PageWrap><Contact onBookNow={() => openBook()} /></PageWrap>} />
        <Route path="*" element={<PageWrap><Home onBookNow={() => openBook()} /></PageWrap>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  const [bookOpen, setBookOpen] = useState(false);
  const [defaultMoto, setDefaultMoto] = useState("");

  const openBook = (moto) => {
    setDefaultMoto(moto || "");
    setBookOpen(true);
  };

  return (
    <div className="App min-h-screen bg-brand-black">
      <BrowserRouter>
        <Header onBookNow={() => openBook()} />
        <RiderScroll />
        <AppRoutes openBook={openBook} />
        <Footer />
        <WhatsAppFAB />
        <BookNowDialog
          open={bookOpen}
          onOpenChange={setBookOpen}
          defaultMoto={defaultMoto}
        />
        <LanguageDetectBanner />
      </BrowserRouter>
      <StructuredData />
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
